import {
  DetailRequirement,
  EngagementTaskTrait,
  ProgramTask,
  RPDataEntry,
  TaskDataUpdates,
  TraitDisplaysItem,
} from '@cibo/core'
import { Section } from '@cibo/ui'
import { Stack, styled } from '@mui/material'
import { Fragment, ReactElement } from 'react'
import { useProgramEngagementContext } from '../../../../context'
import { Display } from '../../Display'
import { TaskEditorComponentProps } from '../../TaskEditorComponent/types'
import { SingleTargetTraitEditor } from './SingleTargetTraitEditor'

type SingleTargetTraitDisplaysProps = {
  traitConfig: EngagementTaskTrait
  taskId: string
  taskConfig: ProgramTask<RPDataEntry>
  saveTaskData: (updates: TaskDataUpdates) => void
  resourceId: string
  traitDisplay?: TraitDisplaysItem
  TaskEditorComponent(props: TaskEditorComponentProps): ReactElement
  noSection?: boolean
  hideTitles?: boolean
}

const TraitEditorSection = styled(Section)(({ theme }) => ({
  flex: 1,
  padding: theme.spacing(3),
}))

export const SingleTargetTraitDisplays = ({
  taskId,
  taskConfig,
  traitConfig,
  traitDisplay,
  resourceId,
  saveTaskData,
  TaskEditorComponent,
  noSection,
  hideTitles,
}: SingleTargetTraitDisplaysProps) => {
  const { taskData } = useProgramEngagementContext()

  const detailRequirements =
    taskData.data?.detailRequirements?.filter(d => d.traitId === traitConfig.traitId) ?? []

  const displays = traitDisplay?.displays || [{ type: 'traitEditor' }]

  if (!displays.length) return null

  return (
    <Stack spacing={2}>
      {displays.map((display, index) => {
        const key = `${resourceId}-${index}-${display.type}`

        switch (display.type) {
          case 'traitEditor': {
            const Wrapper = noSection ? Fragment : TraitEditorSection

            return (
              <Wrapper key={key}>
                <SingleTargetTraitEditor
                  traitConfig={traitConfig}
                  taskId={taskId}
                  detailRequirements={detailRequirements as DetailRequirement[]}
                  taskConfig={taskConfig}
                  saveTaskData={saveTaskData}
                  resourceId={resourceId}
                  traitDisplay={traitDisplay}
                  TaskEditorComponent={TaskEditorComponent}
                  SingleTargetTraitDisplays={SingleTargetTraitDisplays}
                  hideTitles={hideTitles}
                />
              </Wrapper>
            )
          }

          default:
            return (
              <Display
                key={key}
                task={taskConfig}
                display={display}
                TaskEditorComponent={TaskEditorComponent}
              />
            )
        }
      })}
    </Stack>
  )
}
